import { type UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query';
import { ImpersonationBroker, asApiError } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { queryKeys } from './queryKeys';

/** Clears the unread count on a conversation once the rep has it open. */
export function useMarkConversationRead(): UseMutationResult<void, Error, { conversationId: string }> {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation<void, Error, { conversationId: string }>({
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.focusedView.unreadTextConversationsAll });
		},
		mutationFn: async ({ conversationId }) => {
			const result = await userSession.webServiceHelper.callWebServiceAsync<unknown>(
				ImpersonationBroker.composeApiUrl({ urlPath: `Conversation/${conversationId}/read` }),
				'PUT'
			);
			if (!result.success) {
				throw asApiError(result);
			}
		},
		// A stale unread badge is not worth interrupting the rep; log it and move on.
		onError: error => {
			console.error('Mark conversation read error:', error);
		},
	});
}
